// extracted by mini-css-extract-plugin
module.exports = {"container":"lR","recos":"mR","productCardOverride":"nR"};